import { render, staticRenderFns } from "./shareFacebook.vue?vue&type=template&id=276e4450"
import script from "./shareFacebook.vue?vue&type=script&lang=js"
export * from "./shareFacebook.vue?vue&type=script&lang=js"
import style0 from "./shareFacebook.vue?vue&type=style&index=0&id=276e4450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports